import React from 'react';
import {Works} from '../../components/SinglePost';
import PostsSection from "../PostsSection";

export default class WorksSection extends PostsSection {

    render() {
        return (
            <div className="container my-5">

                {super.render()}

                <div className="grid lightbox" data-columns="2" data-gutter="30" data-cell-ratio="5/4">

                    <Works posts={this.state.posts}/>

                </div>

            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/visitors/subscribers/works/WorksSection.js